import { PartnerInterfaceGlobal } from '../models';

export const schainStatusItems = [
  { id: 'origin', name: 'Original' },
  { id: 'complete', name: '1' },
  { id: 'nocomplete', name: '0' },
];

export const DEFAULT_PARTNER: PartnerInterfaceGlobal.IPartnerInfo = {
  id: 300,
  name: 'test2',
  title: 'Test',
  ns: '',
  loginLogo: 'https://new-api.smart-hub.io/storage/logos/test/logo.svg',
  headerLogo: 'https://new-api.smart-hub.io/storage/logos/test/logo.svg',
  favicon: '',
  useGeoedge: false,
  impressionExpiry: 0,
  adstxtTagId: '',
  useTMT: false,
  tmtSettings: {
    partnerId: 0,
    apiKey: '',
    dailyLimit: 0,
    oneTagLimit: 0,
    removeTagTime: 0,
    run10: 0,
    rescanBlocked: 0,
    personalApiEndpoint: ''
  },
  useForensiq: false,
  forensiqSettings: {
    id: 0,
    partnerId: 0,
    user: '',
    limits: 0
  },
  usePM: 0,
  useBotman: 0,
  connectedPixalatePrebid: 0,
  connectedPMPrebid: 0,
  usePixalatePrebid: 0,
  usePixalate: 0,
  usePMPreBid: 0,
  useTitle: 0,
  protectedmediaSettings: {
    id: 0,
    partnerId: 0,
    type: '',
    projectId: '',
    privateKeyId: '',
    privateKey: '',
    clientEmail: '',
    clientId: '',
    authUri: '',
    tokenUri: '',
    authProviderX509CertUrl: '',
    clientX509CertUrl: '',
    pmAccountId: '',
    limitPerDay: 0,
    todayScans: 0
  },
  uuid: '',
  regions: [],
  overQps: false,
  sellersJson: {
    id: 0,
    partnerId: 0,
    contact_email: '',
    contact_domain: '',
    contact_address: '',
    contact_phone: '',
    createdAt: '',
    updatedAt: '',
    is_auto_update: 0
  },
  revshare: 0,
  pixalateSettings: [],
  isSupport: null,
  jivochatSrcId: null,
  geoedgeSettings: {
    id: 0,
    partner_id: 0,
    enable: 0,
    header: '',
    footer: '',
    daily_limit: 0,
    default_key: ''
  },
  botman_settings: {
    partner_id: 0,
    enable_prebid: 0,
    enable_postbid: 0,
    prebid_business_id: '',
    prebid_sub_business_id: '',
    prebid_scan_limit: 0,
    postbidDailyScanLimit: 0,
    postbidMonthlyScanLimit: 0
  },
  tcf_vendor_id: '',
  use_tcf_vendor_id: false,
  use_smarthub_pixalate: 0,
  smarthub_account: 0,
  pixalate_pb_settings: {
    id: 0,
    partner_id: 0,
    ip: 0,
    ifa: 0,
    ua: 0,
    ott: 0,
    def_app: 0,
    domain: 0,
    hr_app: 0,
    dc_subnet: 0
  },
  hasAccessToAudio: false,
  rubicon_settings: {
    id: 0,
    partner_id: 0,
    username: '',
    password: '',
    active: 0,
    company_id: null
  },
  domains: [],
  ssp_max_bidfloor: 0,
  dsp_max_bidprice: 0,
  qps_adapter_percentage: 0,
  has_rubicon_settings: false,
  has_win_rate_booster: 0,
  hide_deleted_endpoints: 0,
  custom_api_statistic: 0,
  prebidIntegration: {
    partner_id: 0,
    wl_prebid: 0,
    js_prebid: 0,
    wl_prebid_time: null,
    js_prebid_time: null
  },
  crid_format: 0,
  pass_user_id: 0,
  use_appname_adjustment: 0,
  appNamesCount: 0,
  useWhiteops: 0,
  useFraudlogix: 0,
  partner_plan: 0,
  partner_domain: '',
  useSsl: 0,
  is_authorized_schain: 0,
  authorized_schain_fileinfo: {
    filename: '',
    count: 0,
    updatedAt: '',
    createdAt: '',
    updated: ''
  },
  app_names_fileinfo: {
    filename: '',
    count: 0,
    updatedAt: '',
    createdAt: ''
  },
  is_source_schain: 0,
  wl_prebid: 0,
  wl_prebid_js: 0,
  is_traffic_analyzer: 0,
  schainCompany: 0,
  is_scheduled_reports: 0,
  schain_authorization: 0,
  allow_zero_margin: 0,
  unlimited_qps_dsp: 0,
  use_media_guard: 0,
  use_fraud_sensor: 0,
  pmp_deals: 0,
  is_gzip_compression: 0,
};